import { useActiveStation } from '../../../../../core/stations/hooks/useActiveStation';

export function useMentionsEnabledForActiveStation() {
  return Boolean(useActiveStation().featuresConfig?.audit?.liveMentionsEnabled);
}
